import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { Apollo, gql } from 'apollo-angular';
import { addFollowrs, getAllDirectory, getAllCategories, getTeamMembers, getBookedSelService, getCatsById, getDirBusinessTypes, getDirectories, getDirectory, getFollowersData, getServices, getUsersData, getUsersFollowers, getUsersFollowing, practiceFollowers, practiceFollowing, professinalFollowing, professionalFollowers, removeFollwers, supplierFollowers, supplierFollowing, getUsersDataPending, addFollowingDataMutation, getFollowingData, updateFollowingDataMutation, deleteFollowingDataMutation, getUserDataStatus, getDirectoryFollowersData, GET_DIRECTORY_BY_ID, GET_DIRECTORIES_BY_STATUS, GET_DIRECTORIES_COUNT, GET_REGISTERED_USERS_CLAIM, getDirBusinessTypesFiltered } from '../queries/detailsPage.query';
import { ToastService } from 'src/app/core/toast.service';
import { Directory, DirectoryInput } from '../../dashboard/modules/my-directory/pages/add-directory/add-directory.component';

@Injectable({
  providedIn: 'root'
})
export class DirDetailsService {
  getUsersFollowing(id: any) {
    throw new Error('Method not implemented.');
  }

  constructor(private apollo: Apollo, private toast: ToastService) { }

  getDirectorybyId(id: string) {

    return this.apollo.use("external").subscribe({
      query: getDirectory,
      variables: { id }
    }).pipe(pluck('data', 'directories_by_pk'));

  }

  removeUser(id) {

    return this.apollo.use("external").subscribe({
      query: removeFollwers,
      variables: { id }
    }).pipe(pluck('data', 'delete_directory_followers'));

  }

  /*getAllDirCats(){
    return this.apollo.use("external").subscribe({
      query : getAllCategories
    }).pipe(pluck('data', 'directory_categories'));

  }*/

  getAllDirectory(limit: number, offset: number, search?: string) {
    let where = {};

    if (search?.trim()) {
      const likeSearch = `%${search.trim()}%`;
      where = {
        _or: [
          { company_name: { _ilike: likeSearch } },
          { name: { _ilike: likeSearch } },
          { address: { _ilike: likeSearch } },
          { pincode: { _ilike: likeSearch } }
        ]
      };
    }

    return this.apollo.use("external").watchQuery({
      query: getAllDirectory,
      variables: {
        limit,
        offset,
        where
      },
    }).valueChanges.pipe(pluck('data', 'directories'));
  }


  getAllDirBusTYpesFiltered(type: string) {
  const where = { type: { _eq: type } };

  return this.apollo.use('external')
    .watchQuery({
      query: getDirBusinessTypesFiltered,
      variables: { where },
      fetchPolicy: 'network-only'
    })
    .valueChanges.pipe(pluck('data', 'directory_business_types'));
}




  getAllDirBusTYpes() {
    return this.apollo.use("external").subscribe({
      query: getDirBusinessTypes
    }).pipe(pluck('data', 'directory_business_types'));

  }

  getDirCatsByBusId(id: string) {

    return this.apollo.use("external").subscribe({
      query: getCatsById,
      variables: { id }
    }).pipe(pluck('data', 'directory_categories'));

  }

  getServices(id: string) {


    return this.apollo.use("external").subscribe({
      query: getServices,
      variables: { id }
    }).pipe(pluck('data', 'directory_appointment_slots'));

  }

  getTeamMembers(id: string) {


    return this.apollo.use("external").subscribe({
      query: getTeamMembers,
      variables: { id }
    }).pipe(pluck('data', 'directory_team_members'));

  }
  getBookesAppt(id: string) {


    return this.apollo.use("external").subscribe({
      query: getBookedSelService,
      variables: { id }
    }).pipe(pluck('data', 'directory_appointments'));

  }
  getBookesApptByMember(id: string) {

  }

  getDirectoriesData(id: string, limit: number, offset: number, searchText?: string) {
    let where: any = {
      directory_category_id: { _eq: id }
    };

    if (searchText?.trim()) {
      const like = `%${searchText.trim()}%`;
      where._or = [
        { company_name: { _ilike: like } },
        { name: { _ilike: like } },
        { address: { _ilike: like } },
        { pincode: { _ilike: like } }
      ];
    }

    return this.apollo.use("external").watchQuery({
      query: getDirectories,
      variables: { limit, offset, where }
    }).valueChanges.pipe(pluck('data', 'directories'));
  }





  async addFollwers(follow): Promise<any> {

    try {

      await this.apollo.use("external").mutate({
        mutation: addFollowrs,
        variables: { followObj: follow }
      }).pipe(pluck('data', 'insert_directory_followers_one')).toPromise();

      this.toast.openSnackBar(
        'you followed succesfully'
      );
      return true;

    } catch (err) {
      console.log(err);
      this.toast.openSnackBar('You Failed To follow');
      return false;

    }

  }

  getPracticeFollowing(id: string) {

    return this.apollo.use("external").subscribe({
      query: practiceFollowing,
      variables: { id }
    }).pipe(pluck('data', 'directory_followers'));

  }


  getSupplierFollowing(id: string) {

    return this.apollo.use("external").subscribe({
      query: supplierFollowing,
      variables: { id }
    }).pipe(pluck('data', 'directory_followers'));

  }



  getProfessionalFollowing(id: string) {

    return this.apollo.use("external").subscribe({
      query: professinalFollowing,
      variables: { id }
    }).pipe(pluck('data', 'directory_followers'));

  }

  getSupplierFollowers(id: string) {

    return this.apollo.use("external").subscribe({
      query: supplierFollowers,
      variables: { id }
    }).pipe(pluck('data', 'directory_followers'));

  }

  getProfessionalFollowers(id: string) {

    return this.apollo.use("external").subscribe({
      query: professionalFollowers,
      variables: { id }
    }).pipe(pluck('data', 'directory_followers'));

  }
  getUserDataStatus(userId: string) {
    return this.apollo.use("external").subscribe({
      query: getUserDataStatus,
      variables: { userId }
    }).pipe(pluck('data', 'directory_followers'));
  }



  getFollowersData(tagIdArray) {

    return this.apollo.subscribe({
      query: getFollowersData,
      variables: { tagIdArray }
    }).pipe(pluck('data', 'clients'));

  }

  getPracticeFollowers(id: string) {

    return this.apollo.use("external").subscribe({
      query: practiceFollowers,
      variables: { id }
    }).pipe(pluck('data', 'directory_followers'));

  }


  getUsersCount(userId: string) {


    return this.apollo.subscribe({
      query: getUsersData,
      variables: { userId }
    }).pipe(pluck('data'));

  }


  getUsersCountPending(userId: string) {


    return this.apollo.subscribe({
      query: getUsersDataPending,
      variables: { userId }
    }).pipe(pluck('data'));

  }

  getUsersDetailsFollowing(userId: string) {

    return this.apollo.subscribe({
      query: getUsersFollowing,
      variables: { userId }
    }).pipe(pluck('data', 'who_is_following'));

  }

  getDirectoryFollowers() {
    return this.apollo.use("external").watchQuery({
      query: getDirectoryFollowersData
    }).valueChanges.pipe(pluck('data', 'directory_followers'));
  }


  getUsersDetailsFollowers(userId: string) {

    return this.apollo.subscribe({
      query: getUsersFollowers,
      variables: { userId }
    }).pipe(pluck('data', 'to_whome_i_am_following'));
  }

  addFollowerData(follow: any): Promise<any> {

    return this.apollo.mutate({
      mutation: addFollowingDataMutation,
      variables: {
        object: follow
      }
    }).toPromise();
  }

  getFollowingList(userId: string): Observable<{ following_user_id: string }[]> {
    return this.apollo.subscribe({
      query: getFollowingData,
      variables: { userId }
    }).pipe(pluck('data', 'user_following'));
  }

  updateFollowStatus(requestId: string, newStatus: string): Promise<any> {
    return this.apollo
      .mutate({
        mutation: updateFollowingDataMutation,
        variables: {
          id: requestId,
          status: newStatus,
        },
      })
      .toPromise()

  }
  deleteFollowStatus(requestId: string,): Promise<any> {
    return this.apollo
      .mutate({
        mutation: deleteFollowingDataMutation,
        variables: {
          id: requestId,

        },
      })
      .toPromise()

  }
  /** Fetch a single directory record by its UUID */
  getDirectoryPreloginByid(id: string): Observable<any> {
    return this.apollo
      .query({
        query: GET_DIRECTORY_BY_ID,
        variables: { id },
        fetchPolicy: 'network-only', // always hit server
      })
      .pipe(map((result: any) => result.data.directories[0]));
  }

  // Fetch unclaimed directories
  getDirectoriesByStatus(status: string, limit: number, offset: number): Observable<Directory[]> {
    let statuses: string[];

    // Handle "All" case
    if (status === 'ALL') {
      statuses = ['UNCLAIMED', 'PENDING'];
    } else {
      statuses = [status];
    }

    return this.apollo
      .watchQuery<{ directories: Directory[] }>({
        query: GET_DIRECTORIES_BY_STATUS,
        variables: { statuses, limit, offset },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map(result => result.data.directories));
  }

  // submitClaim(payload: any) {
  //   return this.apollo
  //     .mutate({
  //       mutation: INSERT_REGISTERED_USER_CLAIM,
  //       variables: { object: payload },
  //     })
  //     .pipe(
  //       map(res => (res.data as any)?.insert_registered_user_claim_one)
  //     );
  // }

  getDirectoriesCount(status: string): Observable<number> {
    let statuses: string[];

    if (status === 'ALL') {
      statuses = ['UNCLAIMED', 'PENDING'];
    } else {
      statuses = [status];
    }

    return this.apollo
      .watchQuery<{ directories_aggregate: { aggregate: { count: number } } }>({
        query: GET_DIRECTORIES_COUNT,
        variables: { statuses },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map(res => res.data.directories_aggregate.aggregate.count)
      );
  }

  // Fetch directory by ID
  // getDirectoryById(id: string): Observable<Directory> {
  //   return this.apollo
  //     .watchQuery<{ directories_by_pk: Directory }>({
  //       query: GET_DIRECTORY_EDIT_ID,
  //       variables: { id },
  //       fetchPolicy: 'network-only',
  //     })
  //     .valueChanges.pipe(map(result => result.data.directories_by_pk));
  // }

  // // Update directory by ID
  // updateDirectory(id: string, changes: DirectoryInput): Observable<Directory> {
  //   return this.apollo.mutate<{ update_directories_by_pk: Directory }>({
  //     mutation: UPDATE_DIRECTORY,
  //     variables: { id, changes },
  //   }).pipe(map(result => result.data!.update_directories_by_pk));
  // }

  // get registered user claim by directory id
  getRegisteredUserClaimByDirectoryId(directoryId: string, limit?: number, offset?: number): Observable<any[]> {
    return this.apollo
      .watchQuery({
        query: GET_REGISTERED_USERS_CLAIM,
        variables: { directoryId, limit, offset },
        fetchPolicy: 'network-only'
      })
      .valueChanges.pipe(map(res => (res.data as any)?.registered_user_claim || []));
  }


  // // Delete registered claims by directory_id
  // deleteRegisteredClaimsByDirectoryId(directoryId: string) {
  //   return this.apollo.mutate({
  //     mutation: gql`
  //       mutation DeleteRegisteredClaims($directoryId: uuid!) {
  //         delete_registered_user_claim(where: { directory_id: { _eq: $directoryId } }) {
  //           affected_rows
  //         }
  //       }
  //     `,
  //     variables: { directoryId }
  //   });
  // }

  // Delete directory
  // deleteDirectory(directoryId: string) {
  //   return this.apollo.mutate({
  //     mutation: gql`
  //       mutation DeleteDirectory($directoryId: uuid!) {
  //         delete_directories_by_pk(id: $directoryId) {
  //           id
  //         }
  //       }
  //     `,
  //     variables: { directoryId }
  //   });
  // }

}